export const isAppAdmin = (appRole) => ['ADMIN'].includes(appRole)
